import React from "react";

const statusConfig = {
  PENDING: { bg: "bg-gray-100", text: "text-gray-700", label: "Setup incomplete" },
  ACTIVATING: { bg: "bg-amber-100", text: "text-amber-700", label: "Activating" },
  ACTIVE: { bg: "bg-green-100", text: "text-green-700", label: "Live" },
  PAUSED: { bg: "bg-amber-100", text: "text-amber-700", label: "Paused" },
  ERROR: { bg: "bg-red-100", text: "text-red-700", label: "Issue detected" },
  ARCHIVED: { bg: "bg-gray-100", text: "text-gray-500", label: "Removed" },
};

const StatusBadge = ({ status }) => {
  const config = statusConfig[status] || statusConfig.PENDING;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;
